import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import { digitsEnToFa } from 'persian-tools2';
import done from 'assets/img/done.svg';

const successStyle = {
  successText: {
    textAlign: 'center',

    fontWeight: '700',
    fontSize: '16px',
    color: '#3BBA4C',
  },
  closeBtn: {
    width: '156px',
    height: '48px',
    
    fontWeight: '700',
    fontSize: '14px',
    color: '#707070',
    background: '#F5F5F5',
    border: '1px solid #FFFFFF',
    boxShadow: ' 4px 4px 15px rgba(172, 172, 172, 0.5), -4px -4px 15px #FFFFFF',
    borderRadius: '16px',
  },
};

const SmsSent = (props) => {
  const { phoneNumber, handleCloseModal } = props;
  return (
    <Grid container padding="0 24px" sx={{ minHeight: '318px' }}>
      <Grid item xs={12} sx={successStyle.successText}>
        <p>گزارش برای شماره {digitsEnToFa(phoneNumber)} با موفقیت ارسال شد.</p>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '30px auto 61px',
        }}
      >
        <img src={done} />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          margin: '0 0 41px',
        }}
      >
        <Button onClick={() => handleCloseModal()} sx={successStyle.closeBtn}>
          بستن
        </Button>
      </Grid>
    </Grid>
  );
};

export default SmsSent;
